import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { BulkBuyerSellersFileCheckerRemarkSaga, BulkBuyerSellersFileMakerRemarkSaga, BulkBuyerSellersFileVersionSaga, bulkBuyerSellersType, downloadBulkBuyerSellersFileSaga, fetchBulkBuyerSellersFileDetailSaga, fetchBulkBuyerSellersFileSaga, uploadBulkBuyerSellersFileSaga } from "./types";
import { approveBulkBuyerSellersFileApi, bulkBuyerSellersFilePublishApi, deleteBulkBuyerSellersFileApi, downloadBulkBuyerSellersFileApi, fetchBulkBuyerSellersApi, fetchBulkBuyerSellersFileDetailApi, fetchBulkBuyerSellersFileVersionApi, fetchBulkFileSpecificBuyerSellersApi, rejectBulkBuyerSellersFileApi, uploadBulkBuyerSellersFileApi } from "./api";

function* uploadBulkBuyerSellersFile({ payload, type }: uploadBulkBuyerSellersFileSaga): SagaIterator {
    try {
        const response = yield call(uploadBulkBuyerSellersFileApi, payload);
        yield put({
            type: bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkBuyerSellersFile({ payload, type }: fetchBulkBuyerSellersFileSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkBuyerSellersApi, payload);
        yield put({
            type: bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* DownloadBulkBuyerSellersFile({ payload, type }: downloadBulkBuyerSellersFileSaga): SagaIterator {
    try {
        const response = yield call(downloadBulkBuyerSellersFileApi, payload);
        const fileURL = payload.downloadURL.split("/")
        const responseData = {
            fileBlob: response.data,
            fileName: fileURL[fileURL.length - 1]
        }
        yield put({
            type: bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD_SUCCESS,
            payload: { data: responseData }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkBuyerSellersFileDetail({ payload, type }: fetchBulkBuyerSellersFileDetailSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkBuyerSellersFileDetailApi, payload);
        yield put({
            type: bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkBuyerSellersFileVersion({ payload, type }: BulkBuyerSellersFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkBuyerSellersFileVersionApi, payload);
        yield put({
            type: bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION_ERROR,
            payload: { error: error }
        });
    }
}

function* publishBulkBuyerSellersFile({ payload, type }: BulkBuyerSellersFileMakerRemarkSaga): SagaIterator {
    try {
        const response = yield call(bulkBuyerSellersFilePublishApi, payload);
        yield put({
            type: bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH_ERROR,
            payload: { error: error }
        });
    }
}

function* approveBulkBuyerSellersFile({ payload, type }: BulkBuyerSellersFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(approveBulkBuyerSellersFileApi, payload);
        yield put({
            type: bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* rejectBulkBuyerSellersFile({ payload, type }: BulkBuyerSellersFileCheckerRemarkSaga): SagaIterator {
    try {
        const response = yield call(rejectBulkBuyerSellersFileApi, payload);
        yield put({
            type: bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}

function* fetchBulkFileSpecificBuyerSellers({ payload, type }: BulkBuyerSellersFileVersionSaga): SagaIterator {
    try {
        const response = yield call(fetchBulkFileSpecificBuyerSellersApi, payload);
        yield put({
            type: bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS_ERROR,
            payload: { error: error }
        });
    }
}

function* deleteBulkBuyerSellersFile({ payload, type }: fetchBulkBuyerSellersFileDetailSaga): SagaIterator {
    try {
        const response = yield call(deleteBulkBuyerSellersFileApi, payload);
        yield put({
            type: bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchUploadBulkBuyerSellersFile() {
    yield takeEvery(bulkBuyerSellersType.UPLOAD_BULK_BUYER_SELLERS_FILE, uploadBulkBuyerSellersFile);
}

export function* watchFetchBulkBuyerSellersFile() {
    yield takeEvery(bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE, fetchBulkBuyerSellersFile);
}

export function* watchDownloadBulkBuyerSellersFile() {
    yield takeEvery(bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_DOWNLOAD, DownloadBulkBuyerSellersFile);
}

export function* watchFetchBulkBuyerSellersFileDetail() {
    yield takeEvery(bulkBuyerSellersType.FETCH_BULK_BUYER_SELLERS_FILE_DETAIL, fetchBulkBuyerSellersFileDetail);
}

export function* watchBulkBuyerSellersFileVersion() {
    yield takeEvery(bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_VERSION, fetchBulkBuyerSellersFileVersion);
}

export function* watchPublishBulkBuyerSellersFile() {
    yield takeEvery(bulkBuyerSellersType.BULK_BUYER_SELLERS_FILE_PUBLISH, publishBulkBuyerSellersFile);
}

export function* watchApproveBulkBuyerSellersFile() {
    yield takeEvery(bulkBuyerSellersType.APPROVE_BULK_BUYER_SELLERS_FILE, approveBulkBuyerSellersFile);
}

export function* watchRejectBulkBuyerSellersFile() {
    yield takeEvery(bulkBuyerSellersType.REJECT_BULK_BUYER_SELLERS_FILE, rejectBulkBuyerSellersFile);
}

export function* watchFetchBulkFileSpecificBuyerSellers() {
    yield takeEvery(bulkBuyerSellersType.FETCH_BULK_FILE_SPECIFIC_BUYER_SELLERS, fetchBulkFileSpecificBuyerSellers);
}

export function* watchDeleteBulkBuyerSellersFile() {
    yield takeEvery(bulkBuyerSellersType.DELETE_BULK_BUYER_SELLERS_FILE, deleteBulkBuyerSellersFile);
}


function* BulkBuyerSellerrSaga() {
    yield all([
        fork(watchUploadBulkBuyerSellersFile),
        fork(watchFetchBulkBuyerSellersFile),
        fork(watchDownloadBulkBuyerSellersFile),
        fork(watchFetchBulkBuyerSellersFileDetail),
        fork(watchBulkBuyerSellersFileVersion),
        fork(watchPublishBulkBuyerSellersFile),
        fork(watchApproveBulkBuyerSellersFile),
        fork(watchRejectBulkBuyerSellersFile),
        fork(watchFetchBulkFileSpecificBuyerSellers),
        fork(watchDeleteBulkBuyerSellersFile)
    ]);
}

export default BulkBuyerSellerrSaga;